import React from "react";
import { Styles } from "./styles";
import { Col, Container, Row } from "react-bootstrap";
import GoogleDownload from "../../../assets/images/home/googlePlay.webp";
import AppleDownload from "../../../assets/images/home/appleStore.webp";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { LightSpeed, Slide } from "react-reveal";
import Pulse from "react-reveal/Pulse";

const Download = ({ data }) => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);

  return (
    <Styles>
      <section id="downloadSection">
        <Container>
          <Row className="align-items-center justify-content-around">
            <Col lg={5}>
              <div className="section-data">
                <Slide top>
                  <div className="section-decription">
                    <div className="title">
                      {Resource?.download_title
                        ? Resource?.download_title
                        : t("home.download.title")}
                    </div>
                    <div className="description">
                      {Resource?.download_description
                        ? Resource?.download_description
                        : t("home.download.description")}
                    </div>
                  </div>
                </Slide>
                <div className="download-buttons">
                  <LightSpeed right>
                    <a target="_blank" href={data?.AppStoreLink}>
                      <img src={AppleDownload} alt="darebni apple-app" />
                    </a>
                  </LightSpeed>
                  <LightSpeed right>
                    <a target="_blank" href={data?.PlayStoreLink}>
                      <img src={GoogleDownload} alt="darebni android-app" />
                    </a>
                  </LightSpeed>
                </div>
              </div>
            </Col>
            <Col
              lg={5}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="section-img">
                <Pulse>
                  <img src={data?.MobileAppAdImage} alt="download" />
                </Pulse>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
};

export default Download;
